/* Springrates product price block — keeps the figures honest.

   Three jobs:
     1. Hulk product options (camber plates, spring upgrades) are priced by the
        app and are NOT part of variant.price. Sum the selected add-ons and
        rewrite every figure in the block. Add-ons are flat, so they shift the
        price and the MSRP equally and the savings figure stays constant.
     2. Keep <shopify-payment-terms> (Shop Pay instalments) in step with the
        selected variant and its add-ons, so the quoted monthly figure matches
        the price on screen.
     3. Same for Affirm. snippets/buy-buttons.liquid renders
        <p class="affirm-as-low-as" data-amount="{{ variant.price }}"> server-side,
        so the figure is stale the moment an add-on is chosen. Affirm reads that
        attribute — NOT the price element — so we rewrite it and call
        affirm.ui.refresh() to re-render the monthly estimate.

   Markup: snippets/sr-price-block.liquid. Styles: assets/sr-price.css. */

(function () {
  "use strict";

  var timer = null;

  function currency() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "USD";
  }

  function money(cents) {
    try {
      return new Intl.NumberFormat(undefined, { style: "currency", currency: currency() }).format(cents / 100);
    } catch (e) {
      return "$" + (cents / 100).toFixed(2);
    }
  }

  /* Swap the number inside an existing formatted string, preserving its wrapper text. */
  function reprice(sample, cents) {
    var num = (cents / 100).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return String(sample).replace(/[\d,]+\.\d{2}/, num);
  }

  function addOnCents() {
    var total = 0;

    var selects = document.querySelectorAll(".hulkapps_option select");
    for (var i = 0; i < selects.length; i++) {
      var opt = selects[i].options[selects[i].selectedIndex];
      if (opt && opt.dataset && opt.dataset.price) {
        total += parseFloat(opt.dataset.price) || 0;
      }
    }

    var checked = document.querySelectorAll(".hulkapps_option input:checked");
    for (var j = 0; j < checked.length; j++) {
      var el = checked[j];
      var p = el.dataset && el.dataset.price;
      if (!p) {
        var label = el.closest("label") || el.parentElement;
        p = label && label.dataset ? label.dataset.price : null;
      }
      if (p) total += parseFloat(p) || 0;
    }

    return Math.round(total * 100);
  }

  function setText(el, text) {
    if (el && el.textContent !== text) el.textContent = text;
  }

  function apply() {
    timer = null;

    var addon = addOnCents();
    var blocks = document.querySelectorAll(".srp");
    var basePrice = 0;
    var variantId = null;

    for (var i = 0; i < blocks.length; i++) {
      var b = blocks[i];
      var base = parseInt(b.getAttribute("data-base-price"), 10) || 0;
      var msrp = parseInt(b.getAttribute("data-base-msrp"), 10) || 0;

      if (!basePrice) basePrice = base;
      if (!variantId) variantId = b.getAttribute("data-variant-id");

      setText(b.querySelector('[data-srp="price"]'), money(base + addon));
      if (msrp > 0) setText(b.querySelector('[data-srp="msrp"]'), money(msrp + addon));
      if (msrp > base) setText(b.querySelector('[data-srp="save"]'), money(msrp - base));

      if (b.getAttribute("data-addon") !== String(addon)) b.setAttribute("data-addon", addon);
    }

    syncInstallments(variantId, basePrice + addon);
    syncAffirm(basePrice + addon);
  }

  /* Affirm renders from its own data-amount attribute (cents), written server-side
     with the bare variant price. Rewrite it, then ask Affirm to re-render. Only
     refresh when something actually changed — refresh() re-renders every promo on
     the page, so calling it on every keystroke/mutation would thrash. */
  function syncAffirm(totalCents) {
    if (!totalCents) return;

    var els = document.querySelectorAll(".affirm-as-low-as");
    var changed = false;

    for (var i = 0; i < els.length; i++) {
      if (els[i].getAttribute("data-amount") !== String(totalCents)) {
        els[i].setAttribute("data-amount", totalCents);
        changed = true;
      }
    }

    if (!changed) return;

    /* affirm.js installs a queueing stub before the real library loads, so calls
       made early are replayed rather than lost. */
    try {
      if (window.affirm && window.affirm.ui && window.affirm.ui.refresh) {
        window.affirm.ui.refresh();
      }
    } catch (e) {}
  }

  function syncInstallments(variantId, totalCents) {
    if (!variantId) return;

    var terms = document.querySelectorAll("shopify-payment-terms");
    for (var i = 0; i < terms.length; i++) {
      var t = terms[i];

      if (t.getAttribute("variant-id") !== variantId) t.setAttribute("variant-id", variantId);
      if (!t.srOriginalMeta) t.srOriginalMeta = t.getAttribute("shopify-meta");
      if (!t.srOriginalMeta || !totalCents) continue;

      var meta;
      try {
        meta = JSON.parse(t.srOriginalMeta);
      } catch (e) {
        continue;
      }
      if (!meta || !meta.variants) continue;

      for (var v = 0; v < meta.variants.length; v++) {
        if (String(meta.variants[v].id) === String(variantId)) {
          var entry = meta.variants[v];
          entry.full_price = reprice(entry.full_price, totalCents);
          var count = entry.number_of_payment_terms;
          if (count > 0) {
            entry.price_per_term = reprice(entry.price_per_term, Math.round(totalCents / count));
          }
          break;
        }
      }

      var next = JSON.stringify(meta);
      if (t.getAttribute("shopify-meta") !== next) t.setAttribute("shopify-meta", next);
    }
  }

  function schedule() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(apply, 60);
  }

  function start() {
    var scope = document.querySelector("product-info") || document.body;

    try {
      new MutationObserver(schedule).observe(scope, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["data-variant-id"]
      });
    } catch (e) {}

    document.addEventListener("change", schedule);
    document.addEventListener("click", function (e) {
      if (e.target && e.target.closest && e.target.closest(".hulkapps_option")) schedule();
    });

    apply();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
